<script lang="ts">
    import lang from '../../lang/language';
    import Card from './Card.svelte';
    import Map from '../../shared_components/Map.svelte';
    import UnderMaintenance from '../../shared_components/UnderMaintenance.svelte';
    import CardSkeleton from './CardSkeleton.svelte';
    import MapPlaceholder from '../../shared_components/MapPlaceholder.svelte';
    import serviceStore from '../../store/service';
    import onReqServiceStore from '../../store/oa_service';
    import { derived } from 'svelte/store';
    import { onMount } from 'svelte';
    import Search from '../../shared_components/Search.svelte';
    import { getUrlParam } from '../../helpers/url';
    import { isDefinedNotNullNotEmpty } from '../../helpers/common';
    import { name, price, type, date } from '../../store/search';

    let services: any = serviceStore.data;
    let serviceCount: any = serviceStore.data.count;
    let isLoading = serviceStore.data.isLoading;
    let isLoadingMore;
    let noMoreDataToLoad;

    let onReqServices: any = onReqServiceStore.data;
    let OAserviceCount: any = onReqServiceStore.data.count;
    let OAisLoading = onReqServiceStore.data.isLoading;
    let OAisLoadingMore;
    let OAnoMoreDataToLoad;

    let showMap = false;
    let mapServices = [];

    let sort = 'Name-Ascending';

    type TabType = 'quick_booking' | 'request_to_book' | 'map';
    let activeTab: TabType = 'quick_booking';

    let criteria: any = { Id: null };

    type.set(getUrlParam('type'));

    $: {
        //reset
        criteria = { Id: null };

        isDefinedNotNullNotEmpty($type)
            ? (criteria.IndustryCategoryGroups = [parseInt($type)])
            : '';
        $name ? (criteria.Name = $name) : '';

        if ($price) {
            const prices = $price.split('-');
            let bookability: any = { RateRange: {} };

            parseInt(prices[0]) > 0
                ? (bookability.RateRange.Min = parseInt(prices[0]))
                : '';
            parseInt(prices[1]) > 0
                ? (bookability.RateRange.Max = parseInt(prices[1]))
                : '';

            criteria.Bookability = bookability;
        }

        if ($date) {
            criteria.Date = $date;
        }

        criteria.Sort = sort;
    }

    $: sort, search();

    $: {
        mapServices = [...$services, ...$onReqServices];
    }

    onMount(search);

    function search() {
        serviceStore.search(criteria);
        onReqServiceStore.search(criteria);
    }

    $: isLoadingMore = $isLoading && $services.length !== 0;
    $: noMoreDataToLoad = $services.length === $serviceCount;
    $: OAisLoadingMore = $OAisLoading && $onReqServices.length !== 0;
    $: OAnoMoreDataToLoad = $onReqServices.length === $OAserviceCount;
</script>

<Search {search} />
<div class="display-container bordered nara-season">
    <div class="display-type">
        <div
            class={'clickable nara-season ' +
                (activeTab === 'quick_booking' ? 'active bordered bg' : 'font')}
            on:click={() => (activeTab = 'quick_booking')}
        >
            {lang.quick_booking}
        </div>
        <!-- <div
            class={'clickable nara-season ' +
                (activeTab === 'request_to_book'
                    ? 'active bordered bg'
                    : 'font')}
            on:click={() => (activeTab = 'request_to_book')}
        >
            {lang.request_to_book}
        </div> -->
        <div
            class={'clickable nara-season ' +
                (activeTab === 'map' ? 'active bordered bg' : 'font')}
            on:click={() => (activeTab = 'map')}
        >
            {lang.map}
        </div>
    </div>
    <div style="display:flex; align-items: center; ">
        <h4 style="margin-right:10px;">{lang.sort_by}:</h4>
        <div class="row">
            <div class="input-wrapper">
                <select class="input-field" type="text" bind:value={sort}>
                    <option value="Name-Ascending" selected
                        >{lang.name_az}</option
                    >
                    <option value="Name-Descending">{lang.name_za}</option>
                    <option value="Rate-Ascending">{lang.price_az}</option>
                    <option value="Rate-Descending">{lang.price_za}</option>
                </select>
            </div>
        </div>
    </div>
</div>
<div
    class={'display-rate ' +
        (activeTab === 'quick_booking' && 'active nara-season')}
>
    <div class="service-wrapper">
        {#each $services as service}
            <Card {service} />
        {/each}
        {#if $isLoading && $services.length === 0}
            <CardSkeleton numberOfSkeleton={12} />
        {/if}
    </div>
    {#if !$isLoading && $services.length === 0}
        <UnderMaintenance />
    {/if}
    {#if !noMoreDataToLoad}
        <div class="row text-center" style="margin-top: 40px">
            <button
                class="search-button inline-block"
                class:loading={isLoadingMore}
                on:click={serviceStore.getNextPage}
            >
                {#if isLoadingMore}
                    {lang.loading}
                {:else}
                    {lang.load_more}
                {/if}
            </button>
        </div>
    {/if}
</div>
<!-- <div
    class={'display-request-to-book ' +
        (activeTab === 'request_to_book' && 'active nara-season')}
>
    <div class="service-wrapper">
        {#each $onReqServices as service}
            <Card {service} />
        {/each}
        {#if $OAisLoading && $onReqServices.length === 0}
            <CardSkeleton numberOfSkeleton={12} />
        {/if}
    </div>

    {#if !$OAisLoading && $onReqServices.length === 0}
        <UnderMaintenance />
    {/if}
    {#if !OAnoMoreDataToLoad}
        <div class="row text-center" style="margin-top: 40px">
            <button
                class="search-button inline-block"
                class:loading={OAisLoadingMore}
                on:click={onReqServiceStore.getNextPage}
            >
                {#if OAisLoadingMore}
                    {lang.loading}
                {:else}
                    {lang.load_more}
                {/if}
            </button>
        </div>
    {/if}
</div> -->
<div class={'display-map ' + (activeTab === 'map' && 'active')}>
    {#if $isLoading && mapServices.length === 0}
        <MapPlaceholder />
    {:else}
        <Map zoomMap={8} services={mapServices} />
    {/if}
    {#if !$isLoading && mapServices.length === 0}
        <UnderMaintenance />
    {/if}
</div>

<style>
    .service-wrapper {
        display: grid;
        grid-template-columns: repeat(3, calc(100% / 3));
        grid-gap: 5px;
        margin-top: 30px;
        /*padding: 5px;*/
    }

    @media screen and (max-width: 800px) {
        .service-wrapper {
            grid-template-columns: 1fr;
        }
    }

    @media screen and (max-width: 400px) {
        .service-wrapper {
            grid-template-columns: 100%;
        }
    }

    .display-type {
        display: flex;
        flex-direction: row;
        gap: 5px;
    }

    .display-container {
        border-bottom: 3px solid #632418;
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: space-between;
    }

    .display-type > div {
        padding: 10px 20px;
        border: 0px;
        color: #632418;
        font-size: 1.5rem;
        transform: translateY(1px);
    }

    .display-type > div.active {
        background-color: #632418;
        color: #ffffff;
        border: 2px solid #632418;
        border-bottom: 0px;
    }

    .display-rate,
    .display-map,
    .display-request-to-book {
        display: none;
    }

    .display-map {
        padding: 20px 10px;
    }

    .display-rate.active,
    .display-map.active,
    .display-request-to-book.active {
        display: block;
    }

    .load-more {
        padding: 20px;
    }
</style>
